import { z } from 'zod/v3';

export const WorkspacePersonaSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  name: z.string(),
  description: z.string().nullable().optional(),
  propertyFilters: z.any().nullable().optional(),
  assignmentRules: z.any().nullable().optional(),
  priority: z.number(),
  isDefault: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const WorkspacePersonaMemberSchema = z.object({
  id: z.string(),
  personaId: z.string(),
  userId: z.string(),
  priority: z.number(),
  createdAt: z.string().datetime(),
});

// Create / Update DTOs
export const CreateWorkspacePersonaDTOSchema = z.object({
  workspaceId: z.string(),
  name: z.string().min(1),
  description: z.string().optional(),
  propertyFilters: z.any().optional(),
  isDefault: z.boolean().optional(),
  priority: z.number().optional(),
});

export const UpdateWorkspacePersonaDTOSchema = z.object({
  id: z.string(),
  name: z.string().min(1).optional(),
  description: z.string().nullable().optional(),
  propertyFilters: z.any().optional(),
  isDefault: z.boolean().optional(),
  priority: z.number().optional(),
});

export const AssignWorkspacePersonaMemberDTOSchema = z.object({
  personaId: z.string(),
  userId: z.string(),
  priority: z.number().optional(),
});

export type WorkspacePersonaDTO = z.infer<typeof WorkspacePersonaSchema>;
export type WorkspacePersonaMemberDTO = z.infer<typeof WorkspacePersonaMemberSchema>;
export type CreateWorkspacePersonaDTO = z.infer<typeof CreateWorkspacePersonaDTOSchema>;
export type UpdateWorkspacePersonaDTO = z.infer<typeof UpdateWorkspacePersonaDTOSchema>;
export type AssignWorkspacePersonaMemberDTO = z.infer<typeof AssignWorkspacePersonaMemberDTOSchema>;

